import { IApplicationState } from '../../types/redux';

export function getMvkLoadingError(state: IApplicationState) {
  return state.mvk.isLoadingError;
}
